import { motion } from "framer-motion";
import { Phone, MessageCircle, Calendar, ArrowRight } from "lucide-react";
import { PHONE, WHATSAPP_URL, IMAGES } from "../../lib/constants";

export default function Contacto() {
    return (
        <section
            id="contacto"
            data-testid="contacto-section"
            className="relative bg-[#050505] py-24 md:py-32 overflow-hidden"
        >
           
            <div className="absolute inset-0">
                <img
                    src={IMAGES.gymDark}
                    alt=""
                    className="w-full h-full object-cover opacity-15"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#050505] via-[#050505]/85 to-[#050505]" />
            </div>

            <div className="relative max-w-7xl mx-auto px-5 md:px-10">
                <motion.div
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, amount: 0.3 }}
                    transition={{ duration: 0.8 }}
                    className="text-center mb-14"
                >
                    <span className="font-display tracking-[0.4em] text-xs text-brand-orange">
                        // EL PRIMER PASO
                    </span>
                    <h2 className="font-display text-5xl md:text-7xl lg:text-8xl mt-4 leading-[0.88] text-brand-text">
                        TU PRÓXIMA VERSIÓN
                        <br />
                        <span className="orange-text">EMPIEZA AQUÍ.</span>
                    </h2>
                    <p className="mt-6 max-w-xl mx-auto text-brand-muted">
                        Reserva tu valoración inicial gratuita. Hablamos
                        directamente por WhatsApp y diseñamos tu plan a medida.
                    </p>
                </motion.div>

                <div className="grid md:grid-cols-3 gap-5 max-w-5xl mx-auto">
                    <a
                        href={WHATSAPP_URL}
                        target="_blank"
                        rel="noreferrer"
                        data-testid="contact-whatsapp"
                        className="group p-7 bg-brand-orange text-black flex flex-col justify-between hover:bg-brand-orangeHover transition-all duration-300 hover:scale-[1.02] min-h-[220px]"
                    >
                        <MessageCircle size={36} strokeWidth={1.5} />
                        <div>
                            <div className="font-display text-3xl leading-none">
                                WHATSAPP
                            </div>
                            <div className="text-sm mt-2 text-black/80">
                                Respuesta inmediata
                            </div>
                            <div className="mt-5 font-display tracking-wider text-xs flex items-center gap-2">
                                ABRIR CHAT
                                <ArrowRight
                                    size={14}
                                    className="group-hover:translate-x-1 transition-transform"
                                />
                            </div>
                        </div>
                    </a>

                    <a
                        href={`tel:${PHONE.replace(/\s/g, "")}`}
                        data-testid="contact-call"
                        className="group p-7 bg-[#0F0F0F] border border-white/10 hover:border-brand-gold flex flex-col justify-between transition-all duration-300 hover:scale-[1.02] min-h-[220px]"
                    >
                        <Phone
                            size={36}
                            strokeWidth={1.5}
                            className="text-brand-gold"
                        />
                        <div>
                            <div className="font-display text-3xl leading-none text-brand-text">
                                LLAMAR
                            </div>
                            <div className="text-sm mt-2 text-brand-muted">
                                Hablar con un entrenador
                            </div>
                            <div className="mt-5 font-display tracking-wider text-xs text-brand-gold flex items-center gap-2">
                                {PHONE}
                                <ArrowRight
                                    size={14}
                                    className="group-hover:translate-x-1 transition-transform"
                                />
                            </div>
                        </div>
                    </a>

                    <a
                        href={WHATSAPP_URL}
                        target="_blank"
                        rel="noreferrer"
                        data-testid="contact-valoracion"
                        className="group p-7 bg-[#0F0F0F] border border-white/10 hover:border-brand-orange flex flex-col justify-between transition-all duration-300 hover:scale-[1.02] min-h-[220px]"
                    >
                        <Calendar
                            size={36}
                            strokeWidth={1.5}
                            className="text-brand-orange"
                        />
                        <div>
                            <div className="font-display text-3xl leading-none text-brand-text">
                                RESERVA
                            </div>
                            <div className="text-sm mt-2 text-brand-muted">
                                Valoración 100% gratuita
                            </div>
                            <div className="mt-5 font-display tracking-wider text-xs text-brand-orange flex items-center gap-2">
                                AGENDAR AHORA
                                <ArrowRight
                                    size={14}
                                    className="group-hover:translate-x-1 transition-transform"
                                />
                            </div>
                        </div>
                    </a>
                </div>
            </div>
        </section>
    );
}
